// extracted by mini-css-extract-plugin
module.exports = {"Container":"About_Container__DjhoG","Main":"About_Main__2DeY9"};